import React from 'react';
import Form, { Field, OnSubmitHandler } from '@atlaskit/form';
import TextField from '@atlaskit/textfield';
import { AsyncSelect } from '@atlaskit/select';

import { formatOptionLabel } from '@/components/primitive';
import { useAutoCompleteController } from '@/controllers';
import KeyPressPromptButton from '@/components/primitive/keypress-prompt-button';

import { SearchableType } from '../types';

import * as styles from './styles';

interface SearchSuggestionProps {
  scope: SearchableType;
  onSubmitHandler: OnSubmitHandler<any>;
}

const SearchSuggestion = ({ scope, onSubmitHandler }: SearchSuggestionProps) => {
  const loadOptions = useAutoCompleteController(scope);

  return (
    <div css={styles.root}>
      <Form onSubmit={onSubmitHandler}>
        {({ formProps }) => (
          <form {...formProps} css={styles.formStyle} noValidate>
            {/* TODO: searchV2: Type properly */}
            <Field<any> name="nextTerms" id="searchSuggestion">
              {({ fieldProps: { id, ...rest } }) => (
                <AsyncSelect
                  placeholder="*"
                  // eslint-disable-next-line react/jsx-props-no-spreading
                  {...rest}
                  isMulti
                  inputId={id}
                  defaultOptions
                  loadOptions={loadOptions}
                  formatOptionLabel={formatOptionLabel}
                  autoFocus
                />
              )}
            </Field>
            {/* FIXME: There's an unsightly border. Remove. */}
            <div css={styles.hiddenField}>
              <Field<any> name="scope" defaultValue={scope}>
                {({ fieldProps }) => (
                  <TextField
                    type="hidden"
                    // eslint-disable-next-line react/jsx-props-no-spreading
                    {...fieldProps}
                  />
                )}
              </Field>
            </div>
            <KeyPressPromptButton type="submit">⏎</KeyPressPromptButton>
          </form>
        )}
      </Form>
    </div>
  );
};

export default SearchSuggestion;
